var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.845.118.975 6.976C-.431 7.55-.282 9.603 1.2 9.957l7.111 1.7 1.744 7.147c.358 1.474 2.395 1.63 2.967.22.145-.354 6.62-16.284 6.855-16.857.53-1.282-.748-2.569-2.032-2.049Z",
    fill: "#fff"
  })));
};

export default SvgSend;